import React, {useState} from "react";
import {Link} from "react-router";
import {Button, Tag, Navbar, Alignment, H5, Tooltip, Popover} from "@blueprintjs/core";
import styled from "styled-components";

import {useLayout} from '/src/layouts/devices-sizes'


const _Navbar = styled(Navbar)`
    margin-bottom: 1em;
`;

const _PopoverContent = styled.div`
    padding: 1em;
    text-align: center;
`;


const LinkTag = ({icon, name, path, subpaths = []}) => {
    const layout = useLayout();

    return (
        <Popover
            interactionKind="hover"
            hoverOpenDelay={100}
            hoverCloseDelay={100}
            disabled={!subpaths.length}
            placement="bottom"
            content={
                <_PopoverContent>
                    {subpaths.map(({path, name: subname, icon}, index) => (
                        <p key={index}>
                            <Link to={path}>
                                <Tag
                                    round large
                                    icon={icon}
                                    interactive={true}
                                >
                                    {`${name} ${subname}`}
                                </Tag>
                        </Link>
                        </p>
                    ))}
                </_PopoverContent>
            }
        >
            <Link to={path}>
                <Tag
                    title={name}
                    round large
                    interactive={true}
                    icon={icon}
                >{layout === 'Desktop' ? name : ""}</Tag>
            </Link>
        </Popover>
    )
}


const ConfirmingTag = ({icon, name, onClick, confirm = false}) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const layout = useLayout();

    return confirm ?
        <Popover
            isOpen={confirmOpen}
            onClose={() => setConfirmOpen(false)}
            position="bottom-left"
            shouldReturnFocusOnClose={true}
            content={
                <_PopoverContent>
                    <H5>Sure?</H5>
                    <Button
                        text="Yes"
                        intent="success"
                        onClick={onClick}
                    />
                </_PopoverContent>
            }
        >
            <Tooltip content={name}>
                <Tag
                    round large
                    interactive={true}
                    icon={icon}
                    onClick={() => setConfirmOpen(!confirmOpen)}
                >{layout === 'Desktop' ? name : ""}</Tag>
            </Tooltip>
        </Popover>
        : <Tooltip content={name}>
            <Tag
                round large
                interactive={true}
                icon={icon}
                onClick={onClick}
            >{layout === 'Desktop' ? name : ""}</Tag>
        </Tooltip>
}


const ResourceNavigationHeader = ({left, right}) => (
    <div>
        <_Navbar>
            <Navbar.Group align={Alignment.LEFT}>
                {
                    left ? left.map(item => {
                        const Component = item.path ? LinkTag : ConfirmingTag;
                        return <Component
                            key={item.name}
                            icon={item.icon}
                            name={item.name}
                            path={item.path}
                            subpaths={item.subpaths}
                            onClick={item.onClick}
                            confirm={item.confirm}
                        />
                    }) : null
                }
            </Navbar.Group>
            <Navbar.Group align={Alignment.RIGHT}>
                {
                    right ? right.map(item => {
                        const Component = item.path ? LinkTag : ConfirmingTag;
                        return <Component
                            key={item.name}
                            icon={item.icon}
                            name={item.name}
                            path={item.path}
                            subpaths={item.subpaths}
                            onClick={item.onClick}
                            confirm={item.confirm}
                        />
                    }) : null
                }
            </Navbar.Group>
        </_Navbar>
    </div>
);

export {ResourceNavigationHeader};